export enum BillingLedgerEntryStatus {
  COMMITTED = "COMMITTED",
  TEMPORARY = "TEMPORARY",
}

export enum PriceComponentsName {
  GST = "GST",
  Subtotal = "Subtotal",
}
